export const environment = {
    staging: false,
    production: false,
    hmr: true
};
